import { FormInstance } from "antd";
import Tokenizer from "fluidpay-tokenizer";
import { useEffect, useState } from "react";

export const useGateway = (
  form: FormInstance,
  providerData: any,
  selectedProvider: any,
  setError: React.Dispatch<React.SetStateAction<string | null>>,
  setRequest: React.Dispatch<React.SetStateAction<any>>,
  setStep: React.Dispatch<React.SetStateAction<number>>,
) => {
  const [gateway, setGateway] = useState<any>(null);

  const [isSaving, setIsSaving] = useState<boolean>(false);

  useEffect(() => {
    if (
      providerData &&
      selectedProvider &&
      providerData.providerName === "FluidPay" &&
      providerData.options["Enabled.PaymnetMethod.Ach"] &&
      selectedProvider.methodType === 1
    ) {
      const tokenizer = new Tokenizer({
        apikey: providerData.options["Tokenizer.PulicKey"],
        url: providerData.options["Tokenizer.Url"],
        container: "#init-container",
        submission: (resp: any) => {
          setIsSaving(false);
          switch (resp.status) {
            case "success":
              setRequest((prev: any) => ({
                ...prev,
                newMethod: {
                  ...form.getFieldsValue(),
                  fluidToken: resp.token || "",
                },
                providerName: providerData.providerName,
              }));
              setStep(3);
              break;
            case "error":
              setError(`Error: ${resp.msg}`);
              break;
          }
        },
        settings: {
          payment: {
            types: ["ach"],
            ach: {
              sec_code: "web",
              showSecCode: true,
            },
          },
          styles: {
            "input:hover, input:focus": {
              "border-color": "#4e79cf",
              "box-shadow": "0 0 0 2px rgba(5, 122, 255, 0.06)",
              "border-inline-end-width": "1px",
              outline: "0",
            },
            ".payment": {
              "padding-top": "16px",
            },
            ".ach > .fieldsetrow": {
              "flex-direction": "column-reverse",
            },
            ".type": {
              width: "calc(32% - 3px)",

              "@media only screen and (max-width: 300px) {width: calc(65% - 4px);}":
                {},
            },
            ".sec-code": {
              width: "calc(17% - 4px)",
              position: "absolute",
              right: "calc(52% - 6px)",
              "@media only screen and (max-width: 300px) {width: calc(35% - 4px); right: 0;}":
                {},
            },
            ".original": {
              padding: "0px",
            },
            ".break": {
              display: "none !important",
            },
            ".fieldsetgroup > .fieldsetrow > .fieldset": {
              "padding-bottom": "16px !important",
            },
            ".ach .fieldsetrow .account": {
              width: "50%",
              "@media only screen and (max-width: 300px) {width: 100%;}": {},
            },
            ".ach .fieldsetrow .account input": {
              width: "calc(100% - 4px)",
              "@media only screen and (max-width: 300px) {width: 100%;}": {},
            },
            ".ach .fieldsetrow .routing": {
              width: "50%",
              display: "flex",
              "justify-content": "end",
              "@media only screen and (max-width: 300px) {width: 100%; display: unset;}":
                {},
            },
            ".ach .fieldsetrow .routing input": {
              width: "calc(100% - 4px)",
              "@media only screen and (max-width: 300px) {width: 100%;}": {},
            },
          },
        },
      });

      setGateway(tokenizer);
    }
  }, [providerData, selectedProvider, setError, setRequest, setStep, form]);

  return { gateway, isSaving, setIsSaving };
};
